import { CreatedInterfaces } from 'interfaces';

import { useGetRequest } from './utils/useGetRequest';

const resource = 'card-holder';

const useGetCardHolder = (id: string, getCardHolderParents = false) => {
  const [{ data, error, loading }, getCardholder] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v2/card_holders/${id}?get_parent_info=${getCardHolderParents}`,
  });

  return {
    cardHolder: data,
    isLoading: loading,
    isError: error,
    getCardholder: getCardholder
  };
};

export default useGetCardHolder;
